var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumber = function SvgNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "number_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".number_svg__st1{fill:none;stroke:#333;stroke-width:1.243;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), /*#__PURE__*/React.createElement("path", {
    d: "M9 19H4c-.9 0-1.4 0-1.7-.3S2 17.9 2 17V7c0-.9 0-1.4.3-1.7S3.1 5 4 5h16c.9 0 1.4 0 1.7.3s.3.8.3 1.7v10c0 .9 0 1.4-.3 1.7s-.8.3-1.7.3H9",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.5 10.9 2.1-2.1v6.6M10.1 10.2c0-1 .9-1.7 1.7-1.7s1.7.6 1.7 1.7c0 1.9-3.3 3.3-3.3 5h3.3M15.6 8.9h2.9l-2 3c1.2 0 2 .7 2 2s-.8 1.7-1.5 1.7-1.2-.4-1.5-.8",
    className: "number_svg__st1"
  })));
};
export default SvgNumber;